import styled from 'styled-components';
import { Body, Heading } from '@lendi-ui/typography';

export const Title = styled(Heading)`
  text-align: left;
`;
export const Text = styled(Body)`
  text-align: left;
`;
